import { sessionStorage } from '@rategravity/frontend/modules/storage';
import Immutable from 'immutable';
import React from 'react';
import { sanitizeModel } from '../../modules/sanitizer';

const SESSION_MODEL = 'session-model';

const storedModel = () =>
  Immutable.fromJS(JSON.parse(sessionStorage.getItem(SESSION_MODEL) || '{}') || {});

export const mergeWithSession = (model) =>
  model.mergeDeepWith((oldVal, newVal, _) => (oldVal == null ? newVal : oldVal), storedModel());

export const clearSession = () => sessionStorage.removeItem(SESSION_MODEL);

export const setSessionValue = (key, prop, value) =>
  sessionStorage.setItem(
    SESSION_MODEL,
    JSON.stringify(storedModel().setIn([key, prop], value).toObject())
  );

export const saveToSession = (model) =>
  sessionStorage.setItem(SESSION_MODEL, JSON.stringify(storedModel().mergeDeep(model).toObject()));

const emptyModel = {
  borrower: {},
  coborrower: {},
  loan: {}
};

// Initialize Empty Session Storage if it doesnt exist.
sessionStorage.setItem(
  SESSION_MODEL,
  sessionStorage.getItem(SESSION_MODEL) || JSON.stringify(emptyModel)
);

export default (Card) => {
  class Wrapped extends React.Component {
    constructor(props) {
      super(props);
      this.state = {
        model: sanitizeModel(mergeWithSession(props.model))
      };
    }

    render() {
      const { onSubmit, onChange, ...props } = this.props;
      return (
        <Card
          {...props}
          model={this.state.model}
          onSubmit={
            onSubmit
              ? () => {
                  saveToSession(this.state.model);
                  onSubmit();
                }
              : null
          }
          onChange={(key, prop, value, callback) => {
            this.setState({
              model: sanitizeModel(this.state.model.setIn([key, prop], value))
            });
            onChange(key, prop, value, callback);
          }}
        />
      );
    }
  }
  Wrapped.id = Card.id;
  Wrapped.completed = ({ model }) => {
    return Card.completed({ model: mergeWithSession(model) });
  };
  return Wrapped;
};



// WEBPACK FOOTER //
// ./src/components/card/session-card.js